import { FC } from 'react';

import { BsCheckCircleFill } from 'react-icons/bs';
import { BsCircle } from 'react-icons/bs';

import { CompanyStep } from '@constants_iqfu';

import styles from './Stepper.module.scss';

type Props = {
  step: keyof typeof CompanyStep;
};

const Stepper: FC<Props> = ({ step }) => {
  const isCreated = () => {
    return step === 'created' || step === 'preparing' || step === 'inputting' || step === 'completed';
  };
  const isPreparing = () => {
    return step === 'preparing' || step === 'inputting' || step === 'completed';
  };
  const isInputting = () => {
    return step === 'inputting' || step === 'completed';
  };
  const isCompleted = () => {
    return step === 'completed';
  };

  return (
    <div className={styles.stepper}>
      <div className={`${styles.each_step} ${!isCreated() && styles.incomplete}`}>
        <div className={styles.step_label}>
          ヒアリングシート
          <br />
          作成中
        </div>
        {isCreated() ? <BsCheckCircleFill /> : <BsCircle />}
      </div>
      <div className={styles.gap_line} />

      <div className={`${styles.each_step} ${!isPreparing() && styles.incomplete}`}>
        <div className={styles.step_label}>
          写真・紹介文
          <br />
          準備中
        </div>
        {isPreparing() ? <BsCheckCircleFill /> : <BsCircle />}
      </div>
      <div className={styles.gap_line} />

      <div className={`${styles.each_step} ${!isInputting() && styles.incomplete}`}>
        <div className={styles.step_label}>入力中</div>
        {isInputting() ? <BsCheckCircleFill /> : <BsCircle />}
      </div>
      <div className={styles.gap_line} />

      <div className={`${styles.each_step} ${!isCompleted() && styles.incomplete}`}>
        <div className={styles.step_label}>登録完了</div>
        {isCompleted() ? <BsCheckCircleFill /> : <BsCircle />}
      </div>
    </div>
  );
};

export default Stepper;
